/* unplugin-vue-components disabled */import script from "./WealthOperationApplyBusinessDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WealthOperationApplyBusinessDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__